import { type VideoQuality } from '../../webrtc/media/media.constants';

/**
 * Gets the device's default video quality
 */
export const getDefaultVideoQuality = (): VideoQuality => 'sd';
